import { APP_ID } from '@/plugins/config';

export function setFavicons() {
    const faviconPath = `/${APP_ID}/img/favicon.ico`;

    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = faviconPath;
    document.head.appendChild(link);
}
